/**
 * This file was @generated using pocketbase-typegen
 */
import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
  Authorigins = '_authOrigins',
  Externalauths = '_externalAuths',
  Mfas = '_mfas',
  Otps = '_otps',
  Superusers = '_superusers',
  Announces = 'announces',
  ApiTokenHistory = 'api_token_history',
  ApiTokens = 'api_tokens',
  Bons = 'bons',
  Cities = 'cities',
  Commands = 'commands',
  CommandsAttachements = 'commands_attachements',
  CommandsHistory = 'commands_history',
  CommandsModeratorSidebar = 'commands_moderator_sidebar',
  CommandsModificationHistory = 'commands_modification_history',
  CommandsSidebar = 'commands_sidebar',
  CommandsStock = 'commands_stock',
  Complaints = 'complaints',
  DokployConfig = 'dokploy_config',
  EnvoiSidebar = 'envoi_sidebar',
  Factures = 'factures',
  FacturesDetails = 'factures_details',
  FacturesModeratorSidebar = 'factures_moderator_sidebar',
  FacturesSidebar = 'factures_sidebar',
  Fees = 'fees',
  GlobalSettings = 'global_settings',
  HistoryLog = 'history_log',
  ImportHistory = 'import_history',
  LivreursStatusesCount = 'livreurs_statuses_count',
  MobileApp = 'mobile_app',
  Packaging = 'packaging',
  StatusesCount = 'statuses_count',
  StockRecords = 'stock_records',
  Stocks = 'stocks',
  TopCities = 'top_cities',
  TopClients = 'top_clients',
  TopDlms = 'top_dlms',
  TrackingStates = 'tracking_states',
  Users = 'users',
  WhatsappMessageEvents = 'whatsapp_message_events',
  WhatsappMessages = 'whatsapp_messages',
}

// Alias types for improved usability
export type IsoDateString = string
export type RecordIdString = string
export type HTMLString = string

// System fields
export type BaseSystemFields<T = never> = {
  id: RecordIdString
  collectionId: string
  collectionName: Collections
  expand?: T
}

export type AuthSystemFields<T = never> = {
  email: string
  emailVisibility: boolean
  username: string
  verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
  collectionRef: string
  created?: IsoDateString
  fingerprint: string
  id: string
  recordRef: string
  updated?: IsoDateString
}

export type ExternalauthsRecord = {
  collectionRef: string
  created?: IsoDateString
  id: string
  provider: string
  providerId: string
  recordRef: string
  updated?: IsoDateString
}

export type MfasRecord = {
  collectionRef: string
  created?: IsoDateString
  id: string
  method: string
  recordRef: string
  updated?: IsoDateString
}

export type OtpsRecord = {
  collectionRef: string
  created?: IsoDateString
  id: string
  password: string
  recordRef: string
  sentTo?: string
  updated?: IsoDateString
}

export type SuperusersRecord = {
  created?: IsoDateString
  email: string
  emailVisibility?: boolean
  id: string
  password: string
  tokenKey: string
  updated?: IsoDateString
  verified?: boolean
}

export type AnnouncesRecord = {
  created?: IsoDateString
  id: string
  is_published?: boolean
  issuer?: RecordIdString
  message: string
  trash?: boolean
  updated?: IsoDateString
}

export enum ApiTokenHistoryTypeOptions {
  'client' = 'client',
  'livreur' = 'livreur',
}
export type ApiTokenHistoryRecord = {
  created?: IsoDateString
  id: string
  old_token: string
  replaced_by?: RecordIdString
  revoked_at: IsoDateString
  type?: ApiTokenHistoryTypeOptions
  updated?: IsoDateString
  user: RecordIdString
}

export enum ApiTokensTypeOptions {
  'livreur' = 'livreur',
  'client' = 'client',
}
export type ApiTokensRecord = {
  created?: IsoDateString
  id: string
  last_used_at?: IsoDateString
  revoked_at?: IsoDateString
  token: string
  type: ApiTokensTypeOptions
  updated?: IsoDateString
  user: RecordIdString
}

export enum BonsTypeOptions {
  'retour client' = 'retour client',
  'retour livreur' = 'retour livreur',
  'ramassage' = 'ramassage',
  'livraison' = 'livraison',
}
export type BonsRecord = {
  client?: RecordIdString
  code: string
  commands?: RecordIdString[]
  created?: IsoDateString
  delivery_man?: RecordIdString
  id: string
  is_done?: boolean
  trash?: boolean
  type: BonsTypeOptions
  updated?: IsoDateString
}

export type CitiesRecord = {
  created?: IsoDateString
  id: string
  name: string
  trash?: boolean
  updated?: IsoDateString
}

export type CommandsRecord = {
  added_by?: RecordIdString
  attachements?: RecordIdString[]
  city?: RecordIdString
  city_changed_count?: number
  client_name?: string
  client_phone?: string
  client_source?: RecordIdString
  code: string
  created?: IsoDateString
  delivered_date?: IsoDateString
  delivery_man?: RecordIdString
  extra_fees?: number
  id: string
  is_dlm_invoiced?: boolean
  is_echange?: boolean
  is_invoiced?: boolean
  is_ramassed?: boolean
  note?: string
  old_id?: string
  package_opened?: boolean
  packaging?: RecordIdString
  price?: number
  price_changed_count?: number
  product_name?: string
  quantity?: number
  receiver_address?: string
  receiver_full_name?: string
  receiver_phone_number?: string
  reported_date?: IsoDateString
  status: RecordIdString
  status_table_order?: number
  status_updated_at?: IsoDateString
  stock_products?: RecordIdString[]
  trash?: boolean
  updated?: IsoDateString
}

export type CommandsAttachementsRecord = {
  created?: IsoDateString
  created_by: RecordIdString
  file: string
  id: string
  updated?: IsoDateString
}

export enum CommandsHistoryTypeOptions {
  'api-client' = 'api-client',
  'whatsapp-read' = 'whatsapp-read',
  'whatsapp-sent' = 'whatsapp-sent',
  'whatsapp-delivered' = 'whatsapp-delivered',
  'user-wp-followup-confirmed' = 'user-wp-followup-confirmed',
  'user-wp-followup-rejected' = 'user-wp-followup-rejected',
  'user-wp-followup-request' = 'user-wp-followup-request',
  'mobile-call' = 'mobile-call',
  'sms' = 'sms',
}
export type CommandsHistoryRecord<Tmetadata = unknown> = {
  action_user?: RecordIdString
  attachements?: RecordIdString[]
  command: RecordIdString
  created?: IsoDateString
  id: string
  metadata?: null | Tmetadata
  note?: string
  reported_date?: IsoDateString
  status: RecordIdString
  type?: CommandsHistoryTypeOptions
  updated?: IsoDateString
}

export type CommandsModeratorSidebarRecord<
  Tcreated_today_count = unknown,
  Tdelivered_and_echange_count = unknown,
  Tno_delivery_man_count = unknown,
  Tnon_ramassed_count = unknown,
  Tupdated_today_count = unknown,
> = {
  created_today_count?: null | Tcreated_today_count
  delivered_and_echange_count?: null | Tdelivered_and_echange_count
  id: string
  no_delivery_man_count?: null | Tno_delivery_man_count
  non_ramassed_count?: null | Tnon_ramassed_count
  updated_today_count?: null | Tupdated_today_count
}

export enum CommandsModificationHistoryFieldChangedOptions {
  'code' = 'code',
  'product_name' = 'product_name',
  'quantity' = 'quantity',
  'delivery_man' = 'delivery_man',
  'client_source' = 'client_source',
  'client_name' = 'client_name',
  'client_phone' = 'client_phone',
  'receiver_full_name' = 'receiver_full_name',
  'receiver_phone_number' = 'receiver_phone_number',
  'receiver_address' = 'receiver_address',
  'city' = 'city',
  'price' = 'price',
  'extra_fees' = 'extra_fees',
  'packaging' = 'packaging',
  'is_echange' = 'is_echange',
  'package_opened' = 'package_opened',
  'trash' = 'trash',
  'stock_products' = 'stock_products',
}
export type CommandsModificationHistoryRecord = {
  action_user: RecordIdString
  command: RecordIdString
  created?: IsoDateString
  field_changed?: CommandsModificationHistoryFieldChangedOptions
  id: string
  new_value?: string
  old_value?: string
  updated?: IsoDateString
}

export type CommandsSidebarRecord<
  Tcreated_today_count = unknown,
  Tdelivered_and_echange_count = unknown,
  Tno_delivery_man_count = unknown,
  Tnon_ramassed_count = unknown,
  Tupdated_today_count = unknown,
> = {
  client_source?: RecordIdString
  created_today_count?: null | Tcreated_today_count
  delivered_and_echange_count?: null | Tdelivered_and_echange_count
  delivery_man?: RecordIdString
  id: string
  no_delivery_man_count?: null | Tno_delivery_man_count
  non_ramassed_count?: null | Tnon_ramassed_count
  updated_today_count?: null | Tupdated_today_count
}

export type CommandsStockRecord = {
  created?: IsoDateString
  id: string
  quantity?: number
  stock: RecordIdString
  updated?: IsoDateString
}

export enum ComplaintsServiceOptions {
  'clientele' = 'clientele',
  'colis' = 'colis',
  'facturation' = 'facturation',
  'ramassage' = 'ramassage',
  'retour' = 'retour',
  'autre' = 'autre',
}
export type ComplaintsRecord = {
  city?: RecordIdString
  code?: string
  created?: IsoDateString
  created_by: RecordIdString
  id: string
  message: string
  object?: string
  service: ComplaintsServiceOptions
  updated?: IsoDateString
}

export type DokployConfigRecord = {
  created?: IsoDateString
  dokploy_base_url?: string
  enabled?: boolean
  id: string
  litestream_compose_id?: string
  updated?: IsoDateString
  x_api_key?: string
}

export type EnvoiSidebarRecord = {
  id: string
  total_unreceived?: number
}

export enum FacturesTypeOptions {
  'client' = 'client',
  'livreur' = 'livreur',
}
export type FacturesRecord = {
  client?: RecordIdString
  clotured_date?: IsoDateString
  code?: string
  created?: IsoDateString
  delivery_man?: RecordIdString
  extra_charges?: number
  id: string
  is_cloture?: boolean
  is_verse?: boolean
  note?: string
  type?: FacturesTypeOptions
  updated?: IsoDateString
  versement_date?: IsoDateString
}

export type FacturesDetailsRecord = {
  charge?: number
  command: RecordIdString
  created?: IsoDateString
  facture: RecordIdString
  id: string
  price?: number
  updated?: IsoDateString
}

export enum FacturesModeratorSidebarTypeOptions {
  'client' = 'client',
  'livreur' = 'livreur',
}
export type FacturesModeratorSidebarRecord = {
  id: string
  type?: FacturesModeratorSidebarTypeOptions
  unclotured_count?: number
}

export type FacturesSidebarRecord = {
  client?: RecordIdString
  delivery_man?: RecordIdString
  id: string
  unclotured_count?: number
}

export enum FeesTypeOptions {
  'client' = 'client',
  'livreur' = 'livreur',
}
export type FeesRecord = {
  city?: RecordIdString[]
  created?: IsoDateString
  delivered_fees?: number
  id: string
  old_id?: string
  refused_fees?: number
  returned_fees?: number
  trash?: boolean
  type: FeesTypeOptions
  updated?: IsoDateString
  user?: RecordIdString
}

export enum GlobalSettingsClientCodeOptions {
  'QUICKBOX' = 'QUICKBOX',
}
export type GlobalSettingsRecord = {
  CLIENT_CODE?: GlobalSettingsClientCodeOptions
  DEV_enable_change_status_api?: boolean
  DEV_enable_sync_commands_api?: boolean
  WHATSAPP_ACCESS_TOKEN?: string
  WHATSAPP_APP_SECRET?: string
  WHATSAPP_PHONE_NUMBER_ID?: string
  WHATSAPP_WEBHOOK_TOKEN?: string
  app_name: string
  command_prefix: string
  commands_count_added_today?: number
  created?: IsoDateString
  currency: string
  default_row_limit?: number
  enable_auto_close_bons_livraison?: boolean
  enable_auto_close_factures?: boolean
  enable_auto_delivery_man?: boolean
  id: string
  inactivity_days_retour_livreur_treshhold?: number
  is_whatsapp_api_enabled?: boolean
  logo?: string
  logo_tiny?: string
  sms_content?: string
  updated?: IsoDateString
  whatsapp_followup_template_image?: string
}

export type HistoryLogRecord = {
  content?: string
  created?: IsoDateString
  id: string
  updated?: IsoDateString
}

export type ImportHistoryRecord<Tcommands_id = unknown> = {
  cities_created?: RecordIdString[]
  commands_id?: null | Tcommands_id
  created?: IsoDateString
  file: string
  id: string
  import_time_ms?: number
  imported_by?: RecordIdString
  original_filename?: string
  row_count?: number
  stocks_used?: RecordIdString[]
  updated?: IsoDateString
}

export type LivreursStatusesCountRecord = {
  command_count?: number
  delivery_man?: RecordIdString
  id: string
  status: RecordIdString
}

export type MobileAppRecord = {
  android_url?: string
  apk: string
  app_name: string
  created?: IsoDateString
  description?: string
  id: string
  is_active?: boolean
  updated?: IsoDateString
  version: string
}

export type PackagingRecord = {
  created?: IsoDateString
  id: string
  price?: number
  title: string
  trash?: boolean
  updated?: IsoDateString
}

export type StatusesCountRecord = {
  command_count?: number
  id: string
  status: RecordIdString
}

export type StockRecordsRecord = {
  created?: IsoDateString
  created_by: RecordIdString
  id: string
  note?: string
  quantity?: number
  updated?: IsoDateString
}

export type StocksRecord = {
  created?: IsoDateString
  id: string
  is_received?: boolean
  quantity_delivered?: number
  quantity_out?: number
  reference?: string
  stock_records?: RecordIdString[]
  title: string
  trash?: boolean
  updated?: IsoDateString
  user: RecordIdString
}

export type TopCitiesRecord = {
  city?: RecordIdString
  delivered_count?: number
  id: string
}

export type TopClientsRecord = {
  client_source?: RecordIdString
  delivered_count?: number
  id: string
}

export type TopDlmsRecord = {
  delivered_count?: number
  delivery_man?: RecordIdString
  id: string
}

export enum TrackingStatesAllowedRolesOptions {
  'livreur' = 'livreur',
  'client' = 'client',
  'moderateur' = 'moderateur',
}

export enum TrackingStatesTypeOptions {
  'success' = 'success',
  'pending' = 'pending',
  'failed' = 'failed',
}

export enum TrackingStatesReferenceTypeOptions {
  'pending' = 'pending',
  'ramassed' = 'ramassed',
  'reported' = 'reported',
  'prepared_for_expedition' = 'prepared_for_expedition',
  'seen_by_delivery_man' = 'seen_by_delivery_man',
  'retour_client' = 'retour_client',
  'retour_livreur' = 'retour_livreur',
  'interested' = 'interested',
  'en cours' = 'en cours',
  'programmed' = 'programmed',
  'change' = 'change',
  'no answer' = 'no answer',
  'no answer 2nd' = 'no answer 2nd',
  'no answer 3rd' = 'no answer 3rd',
  'cancelled' = 'cancelled',
  'injoignable' = 'injoignable',
  'confirmed' = 'confirmed',
  'refused' = 'refused',
  'hors_zone' = 'hors_zone',
  'change_client' = 'change_client',
  'change_number' = 'change_number',
  'whatsapp_command_report_request' = 'whatsapp_command_report_request',
}

export enum TrackingStatesPrimeDeliveryApiStatusCodeOptions {
  'DELIVERED' = 'DELIVERED',
  'POSTPONED' = 'POSTPONED',
  'NOANSWER' = 'NOANSWER',
  'UNREACHABLE' = 'UNREACHABLE',
  'OUT_OF_AREA' = 'OUT_OF_AREA',
  'CANCELED' = 'CANCELED',
  'REFUSE' = 'REFUSE',
  'RETURN_BY_AMANA' = 'RETURN_BY_AMANA',
  'ERR' = 'ERR',
  'DEUXIEME' = 'DEUXIEME',
  'TROIXIEME' = 'TROIXIEME',
  'PROG' = 'PROG',
  'BOITE_VOCALE' = 'BOITE_VOCALE',
  'TRAVEL' = 'TRAVEL',
  'INTERESTED' = 'INTERESTED',
}

export enum TrackingStatesBoxshipApiStatusCodeOptions {
  'DELIVERED' = 'DELIVERED',
  'POSTPONED' = 'POSTPONED',
  'NOANSWER' = 'NOANSWER',
  'UNREACHABLE' = 'UNREACHABLE',
  'OUT_OF_AREA' = 'OUT_OF_AREA',
  'CANCELED' = 'CANCELED',
  'REFUSE' = 'REFUSE',
  'ERR' = 'ERR',
  'DEUX' = 'DEUX',
  'TROIS' = 'TROIS',
  'CLIENT_INTERESE' = 'CLIENT_INTERESE',
  'CANCELED_BY_VENDEUR' = 'CANCELED_BY_VENDEUR',
  'PROGRAMMER' = 'PROGRAMMER',
  'RELENCE_NEW_CLIENT' = 'RELENCE_NEW_CLIENT',
  'ENRT' = 'ENRT',
  'CNFRMD' = 'CNFRMD',
  'ENVG' = 'ENVG',
  'SUIVI' = 'SUIVI',
  'SRT' = 'SRT',
  'RECU_PAR_CLIENT' = 'RECU_PAR_CLIENT',
}

export enum TrackingStatesColisspeedDeliveryApiStatusCodeOptions {
  'DELIVERED' = 'DELIVERED',
  'POSTPONED' = 'POSTPONED',
  'NOANSWER' = 'NOANSWER',
  'UNREACHABLE' = 'UNREACHABLE',
  'OUT_OF_AREA' = 'OUT_OF_AREA',
  'CANCELED' = 'CANCELED',
  'REFUSE' = 'REFUSE',
  'DOUBLE' = 'DOUBLE',
  'ERR' = 'ERR',
  'PROG' = 'PROG',
  'BOITE_VOCALE' = 'BOITE_VOCALE',
  'TRAVEL' = 'TRAVEL',
  'INTERESTED' = 'INTERESTED',
  'FAUX' = 'FAUX',
  'RETURN_BY_AMANA' = 'RETURN_BY_AMANA',
  'TROIS' = 'TROIS',
  'DEUX' = 'DEUX',
  'CANCELED_2' = 'CANCELED_2',
  'VILLE' = 'VILLE',
  'INJ' = 'INJ',
  'INJB' = 'INJB',
  'CON' = 'CON',
}

export enum TrackingStatesColinoExpressApiStatusCodeOptions {
  'DELIVERED' = 'DELIVERED',
  'POSTPONED' = 'POSTPONED',
  'NOANSWER' = 'NOANSWER',
  'UNREACHABLE' = 'UNREACHABLE',
  'OUT_OF_AREA' = 'OUT_OF_AREA',
  'CANCELED' = 'CANCELED',
  'REFUSE' = 'REFUSE',
  'PAS_RECU' = 'PAS_RECU',
  'ERR' = 'ERR',
  'DISTRIBUTION' = 'DISTRIBUTION',
  'DEUX' = 'DEUX',
  'TROIS' = 'TROIS',
  'CLIENT_INTERESE' = 'CLIENT_INTERESE',
  'CANCELED_BY_VENDEUR' = 'CANCELED_BY_VENDEUR',
  'PROGRAMMER' = 'PROGRAMMER',
  'EN_VOYAGE' = 'EN_VOYAGE',
  'RELENCE_NEW_CLIENT' = 'RELENCE_NEW_CLIENT',
  'WAIT_RELANCE' = 'WAIT_RELANCE',
  'BV' = 'BV',
  'NON_REU' = 'NON_REU',
  'CONFIRM' = 'CONFIRM',
  'VILLE' = 'VILLE',
  'PRS' = 'PRS',
  'INTER' = 'INTER',
}

export enum TrackingStatesGroupchamalApiStatusCodeOptions {
  'DELIVERED' = 'DELIVERED',
  'POSTPONED' = 'POSTPONED',
  'NOANSWER' = 'NOANSWER',
  'UNREACHABLE' = 'UNREACHABLE',
  'OUT_OF_AREA' = 'OUT_OF_AREA',
  'CANCELED' = 'CANCELED',
  'REFUSE' = 'REFUSE',
  'ERR' = 'ERR',
  'DISTRIBUTION' = 'DISTRIBUTION',
  'DEUX' = 'DEUX',
  'TROIS' = 'TROIS',
  'CLIENT_INTERESE' = 'CLIENT_INTERESE',
  'CANCELED_BY_VENDEUR' = 'CANCELED_BY_VENDEUR',
  'PROGRAMMER' = 'PROGRAMMER',
  'EN_VOYAGE' = 'EN_VOYAGE',
  'WAIT_RELANCE' = 'WAIT_RELANCE',
  'BV' = 'BV',
}

export enum TrackingStatesAlloshipApiStatusCodeOptions {
  'En Attente' = 'En Attente',
  'Annulé' = 'Annulé',
  'Client en Voyage' = 'Client en Voyage',
  'Hors zone' = 'Hors zone',
  'Injoignable' = 'Injoignable',
  'Livré' = 'Livré',
  'Numéro Erroné' = 'Numéro Erroné',
  'Pas de Réponse jour 1' = 'Pas de Réponse jour 1',
  'Programmé' = 'Programmé',
  'Refusé' = 'Refusé',
  'Reporté' = 'Reporté',
}

export enum TrackingStatesLivre24ApiStatusCodeOptions {
  'Annulé' = 'Annulé',
  'Hors zone' = 'Hors zone',
  'Injoignable' = 'Injoignable',
  'Livré' = 'Livré',
  'Programmé' = 'Programmé',
  'Refusé' = 'Refusé',
  'Reporté' = 'Reporté',
  'En voyage' = 'En voyage',
  'Faux destination' = 'Faux destination',
  'Mise en distribution' = 'Mise en distribution',
  'Pas de réponse' = 'Pas de réponse',
  'Pas de réponse 2 fois' = 'Pas de réponse 2 fois',
  'Pas de réponse 3 fois' = 'Pas de réponse 3 fois',
}

export enum TrackingStatesMyexpressApiStatusCodeOptions {
  'reported' = 'reported',
  'unreachable' = 'unreachable',
  'out_of_range' = 'out_of_range',
  'partially_delivered' = 'partially_delivered',
  'refunded' = 'refunded',
  'recovered' = 'recovered',
  'delivered' = 'delivered',
  'canceled' = 'canceled',
  'rejected' = 'rejected',
  'delivering' = 'delivering',
  'no_response' = 'no_response',
}

export enum TrackingStatesMathioApiStatusCodeOptions {
  'livre' = 'livre',
  'annule' = 'annule',
  'reporte' = 'reporte',
  'programme' = 'programme',
  'refuse' = 'refuse',
  'hors_zone' = 'hors_zone',
  'numero_errone' = 'numero_errone',
  'injoignable' = 'injoignable',
  'boite_vocale' = 'boite_vocale',
  'deuxieme_appel_pas_reponse' = 'deuxieme_appel_pas_reponse',
  'troisieme_appel_pas_reponse' = 'troisieme_appel_pas_reponse',
  'client_interesse' = 'client_interesse',
}
export type TrackingStatesRecord = {
  afradelivery_api_status?: number
  alloship_api_status_code?: TrackingStatesAlloshipApiStatusCodeOptions
  allowed_roles: TrackingStatesAllowedRolesOptions[]
  bg_color: string
  border_color?: string
  boxship_api_status_code?: TrackingStatesBoxshipApiStatusCodeOptions
  colino_express_api_status_code?: TrackingStatesColinoExpressApiStatusCodeOptions
  colisspeed_delivery_api_status_code?: TrackingStatesColisspeedDeliveryApiStatusCodeOptions
  created?: IsoDateString
  created_by?: RecordIdString
  elog_api_status_code?: string
  groupchamal_api_status_code?: TrackingStatesGroupchamalApiStatusCodeOptions
  id: string
  is_default?: boolean
  is_delivered?: boolean
  is_expedie_default?: boolean
  is_returned?: boolean
  is_visible?: boolean
  livre24_api_status_code?: TrackingStatesLivre24ApiStatusCodeOptions
  mathio_api_status_code?: TrackingStatesMathioApiStatusCodeOptions
  myexpress_api_status_code?: TrackingStatesMyexpressApiStatusCodeOptions
  name: string
  old_id?: string
  order?: number
  prime_delivery_api_status_code?: TrackingStatesPrimeDeliveryApiStatusCodeOptions
  reference_type?: TrackingStatesReferenceTypeOptions
  seconde_delivery_api_status_code?: number
  skyparcel_api_status_code?: string
  speedex_taoufik_status_id?: number
  table_order?: number
  text_color?: string
  trash?: boolean
  type: TrackingStatesTypeOptions
  updated?: IsoDateString
}

export enum UsersRolesOptions {
  'Annonces' = 'Annonces',
  'Villes' = 'Villes',
  'Livreurs' = 'Livreurs',
  'Frais de livraison' = 'Frais de livraison',
  'Clients' = 'Clients',
  'Envois' = 'Envois',
  'Stocks' = 'Stocks',
  'Etats' = 'Etats',
  'Emballages' = 'Emballages',
  'Ramassage' = 'Ramassage',
  'Commandes' = 'Commandes',
  'BLS' = 'BLS',
  'Factures clients' = 'Factures clients',
  'Factures livreurs' = 'Factures livreurs',
  'Moderateurs' = 'Moderateurs',
  'Modification etat commandes' = 'Modification etat commandes',
  'Reclamations' = 'Reclamations',
  'Depences' = 'Depences',
  'Lecture commands' = 'Lecture commands',
  'Lecture ramassage' = 'Lecture ramassage',
  'API' = 'API',
  'Commandes suppression' = 'Commandes suppression',
}

export enum UsersTypeOptions {
  'livreur' = 'livreur',
  'client' = 'client',
  'moderateur' = 'moderateur',
}

export enum UsersApiTypeOptions {
  'e-log' = 'e-log',
  'est-livraison' = 'est-livraison',
  'speedex-delivery' = 'speedex-delivery',
  'ghazali-delivery' = 'ghazali-delivery',
  'prime-delivery' = 'prime-delivery',
  'skyparcel' = 'skyparcel',
  'seconde-delivery' = 'seconde-delivery',
  'alloship' = 'alloship',
  'colino-express' = 'colino-express',
  'colis-speed' = 'colis-speed',
  'livo' = 'livo',
  'boxship' = 'boxship',
  'zakrix' = 'zakrix',
  'group-chamal' = 'group-chamal',
  'livre24' = 'livre24',
  'asapdelivery' = 'asapdelivery',
  'afradelivery' = 'afradelivery',
  'myexpress' = 'myexpress',
  'speedex-taoufik' = 'speedex-taoufik',
  'mathio' = 'mathio',
}

export enum UsersDlmPermissionsOptions {
  'MODIFY_COMMAND_CITY' = 'MODIFY_COMMAND_CITY',
}

export enum UsersLastPlatformOptions {
  'mobile' = 'mobile',
  'web' = 'web',
}

export enum UsersLastOsOptions {
  'ios' = 'ios',
  'android' = 'android',
  'pc' = 'pc',
}

export enum UsersLivreurApiTypeOptions {
  'default' = 'default',
  'medex' = 'medex',
}
export type UsersRecord = {
  CIN?: string
  active?: boolean
  allowed_command_cities?: RecordIdString[]
  allowed_facture_livreurs?: RecordIdString[]
  api_is_enabled?: boolean
  api_token?: string
  api_type?: UsersApiTypeOptions
  bank_name?: string
  city?: RecordIdString
  created?: IsoDateString
  default_row_limit?: number
  dlm_permissions?: UsersDlmPermissionsOptions
  email: string
  emailVisibility?: boolean
  endpoint?: string
  facture_scope_enabled?: boolean
  full_name: string
  id: string
  is_original?: boolean
  last_activity_at?: IsoDateString
  last_app_version?: string
  last_login_at?: IsoDateString
  last_os?: UsersLastOsOptions
  last_platform?: UsersLastPlatformOptions
  last_updated_by_user?: RecordIdString
  livreur_api_type?: UsersLivreurApiTypeOptions
  old_id?: string
  password: string
  password_plain?: string
  phone?: string
  push_token?: string
  push_token_updated_at?: IsoDateString
  rib?: string
  roles?: UsersRolesOptions[]
  seconde_delivery_x_api_email?: string
  store_name?: string
  tokenKey: string
  trash?: boolean
  type: UsersTypeOptions
  updated?: IsoDateString
  verified?: boolean
  website?: string
}

export enum WhatsappMessageEventsEventTypeOptions {
  'sent' = 'sent',
  'delivered' = 'delivered',
  'read' = 'read',
  'button_clicked' = 'button_clicked',
  'failed' = 'failed',
}
export type WhatsappMessageEventsRecord<Traw_payload = unknown> = {
  created?: IsoDateString
  event_type: WhatsappMessageEventsEventTypeOptions
  event_value?: string
  id: string
  message_id?: RecordIdString[]
  raw_payload?: null | Traw_payload
  updated?: IsoDateString
}

export enum WhatsappMessagesDirectionOptions {
  'inbound' = 'inbound',
  'outbound' = 'outbound',
}

export enum WhatsappMessagesTypeOptions {
  'template' = 'template',
  'text' = 'text',
  'button' = 'button',
}
export type WhatsappMessagesRecord = {
  command_id?: RecordIdString[]
  context_id?: string
  created?: IsoDateString
  direction: WhatsappMessagesDirectionOptions
  id: string
  message_body?: string
  phone_number_id?: string
  template_name?: string
  type: WhatsappMessagesTypeOptions
  updated?: IsoDateString
  wa_message_id?: string
  wa_user_id: string
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> =
  Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> =
  Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> &
  BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> &
  BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> &
  AuthSystemFields<Texpand>
export type AnnouncesResponse<Texpand = unknown> = Required<AnnouncesRecord> &
  BaseSystemFields<Texpand>
export type ApiTokenHistoryResponse<Texpand = unknown> =
  Required<ApiTokenHistoryRecord> & BaseSystemFields<Texpand>
export type ApiTokensResponse<Texpand = unknown> = Required<ApiTokensRecord> &
  BaseSystemFields<Texpand>
export type BonsResponse<Texpand = unknown> = Required<BonsRecord> &
  BaseSystemFields<Texpand>
export type CitiesResponse<Texpand = unknown> = Required<CitiesRecord> &
  BaseSystemFields<Texpand>
export type CommandsResponse<Texpand = unknown> = Required<CommandsRecord> &
  BaseSystemFields<Texpand>
export type CommandsAttachementsResponse<Texpand = unknown> =
  Required<CommandsAttachementsRecord> & BaseSystemFields<Texpand>
export type CommandsHistoryResponse<
  Tmetadata = unknown,
  Texpand = unknown,
> = Required<CommandsHistoryRecord<Tmetadata>> & BaseSystemFields<Texpand>
export type CommandsModeratorSidebarResponse<
  Tcreated_today_count = unknown,
  Tdelivered_and_echange_count = unknown,
  Tno_delivery_man_count = unknown,
  Tnon_ramassed_count = unknown,
  Tupdated_today_count = unknown,
  Texpand = unknown,
> = Required<
  CommandsModeratorSidebarRecord<
    Tcreated_today_count,
    Tdelivered_and_echange_count,
    Tno_delivery_man_count,
    Tnon_ramassed_count,
    Tupdated_today_count
  >
> &
  BaseSystemFields<Texpand>
export type CommandsModificationHistoryResponse<Texpand = unknown> =
  Required<CommandsModificationHistoryRecord> & BaseSystemFields<Texpand>
export type CommandsSidebarResponse<
  Tcreated_today_count = unknown,
  Tdelivered_and_echange_count = unknown,
  Tno_delivery_man_count = unknown,
  Tnon_ramassed_count = unknown,
  Tupdated_today_count = unknown,
  Texpand = unknown,
> = Required<
  CommandsSidebarRecord<
    Tcreated_today_count,
    Tdelivered_and_echange_count,
    Tno_delivery_man_count,
    Tnon_ramassed_count,
    Tupdated_today_count
  >
> &
  BaseSystemFields<Texpand>
export type CommandsStockResponse<Texpand = unknown> =
  Required<CommandsStockRecord> & BaseSystemFields<Texpand>
export type ComplaintsResponse<Texpand = unknown> = Required<ComplaintsRecord> &
  BaseSystemFields<Texpand>
export type DokployConfigResponse<Texpand = unknown> =
  Required<DokployConfigRecord> & BaseSystemFields<Texpand>
export type EnvoiSidebarResponse<Texpand = unknown> =
  Required<EnvoiSidebarRecord> & BaseSystemFields<Texpand>
export type FacturesResponse<Texpand = unknown> = Required<FacturesRecord> &
  BaseSystemFields<Texpand>
export type FacturesDetailsResponse<Texpand = unknown> =
  Required<FacturesDetailsRecord> & BaseSystemFields<Texpand>
export type FacturesModeratorSidebarResponse<Texpand = unknown> =
  Required<FacturesModeratorSidebarRecord> & BaseSystemFields<Texpand>
export type FacturesSidebarResponse<Texpand = unknown> =
  Required<FacturesSidebarRecord> & BaseSystemFields<Texpand>
export type FeesResponse<Texpand = unknown> = Required<FeesRecord> &
  BaseSystemFields<Texpand>
export type GlobalSettingsResponse<Texpand = unknown> =
  Required<GlobalSettingsRecord> & BaseSystemFields<Texpand>
export type HistoryLogResponse<Texpand = unknown> = Required<HistoryLogRecord> &
  BaseSystemFields<Texpand>
export type ImportHistoryResponse<
  Tcommands_id = unknown,
  Texpand = unknown,
> = Required<ImportHistoryRecord<Tcommands_id>> & BaseSystemFields<Texpand>
export type LivreursStatusesCountResponse<Texpand = unknown> =
  Required<LivreursStatusesCountRecord> & BaseSystemFields<Texpand>
export type MobileAppResponse<Texpand = unknown> = Required<MobileAppRecord> &
  BaseSystemFields<Texpand>
export type PackagingResponse<Texpand = unknown> = Required<PackagingRecord> &
  BaseSystemFields<Texpand>
export type StatusesCountResponse<Texpand = unknown> =
  Required<StatusesCountRecord> & BaseSystemFields<Texpand>
export type StockRecordsResponse<Texpand = unknown> =
  Required<StockRecordsRecord> & BaseSystemFields<Texpand>
export type StocksResponse<Texpand = unknown> = Required<StocksRecord> &
  BaseSystemFields<Texpand>
export type TopCitiesResponse<Texpand = unknown> = Required<TopCitiesRecord> &
  BaseSystemFields<Texpand>
export type TopClientsResponse<Texpand = unknown> = Required<TopClientsRecord> &
  BaseSystemFields<Texpand>
export type TopDlmsResponse<Texpand = unknown> = Required<TopDlmsRecord> &
  BaseSystemFields<Texpand>
export type TrackingStatesResponse<Texpand = unknown> =
  Required<TrackingStatesRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> &
  AuthSystemFields<Texpand>
export type WhatsappMessageEventsResponse<
  Traw_payload = unknown,
  Texpand = unknown,
> = Required<WhatsappMessageEventsRecord<Traw_payload>> &
  BaseSystemFields<Texpand>
export type WhatsappMessagesResponse<Texpand = unknown> =
  Required<WhatsappMessagesRecord> & BaseSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
  _authOrigins: AuthoriginsRecord
  _externalAuths: ExternalauthsRecord
  _mfas: MfasRecord
  _otps: OtpsRecord
  _superusers: SuperusersRecord
  announces: AnnouncesRecord
  api_token_history: ApiTokenHistoryRecord
  api_tokens: ApiTokensRecord
  bons: BonsRecord
  cities: CitiesRecord
  commands: CommandsRecord
  commands_attachements: CommandsAttachementsRecord
  commands_history: CommandsHistoryRecord
  commands_moderator_sidebar: CommandsModeratorSidebarRecord
  commands_modification_history: CommandsModificationHistoryRecord
  commands_sidebar: CommandsSidebarRecord
  commands_stock: CommandsStockRecord
  complaints: ComplaintsRecord
  dokploy_config: DokployConfigRecord
  envoi_sidebar: EnvoiSidebarRecord
  factures: FacturesRecord
  factures_details: FacturesDetailsRecord
  factures_moderator_sidebar: FacturesModeratorSidebarRecord
  factures_sidebar: FacturesSidebarRecord
  fees: FeesRecord
  global_settings: GlobalSettingsRecord
  history_log: HistoryLogRecord
  import_history: ImportHistoryRecord
  livreurs_statuses_count: LivreursStatusesCountRecord
  mobile_app: MobileAppRecord
  packaging: PackagingRecord
  statuses_count: StatusesCountRecord
  stock_records: StockRecordsRecord
  stocks: StocksRecord
  top_cities: TopCitiesRecord
  top_clients: TopClientsRecord
  top_dlms: TopDlmsRecord
  tracking_states: TrackingStatesRecord
  users: UsersRecord
  whatsapp_message_events: WhatsappMessageEventsRecord
  whatsapp_messages: WhatsappMessagesRecord
}

export type CollectionResponses = {
  _authOrigins: AuthoriginsResponse
  _externalAuths: ExternalauthsResponse
  _mfas: MfasResponse
  _otps: OtpsResponse
  _superusers: SuperusersResponse
  announces: AnnouncesResponse
  api_token_history: ApiTokenHistoryResponse
  api_tokens: ApiTokensResponse
  bons: BonsResponse
  cities: CitiesResponse
  commands: CommandsResponse
  commands_attachements: CommandsAttachementsResponse
  commands_history: CommandsHistoryResponse
  commands_moderator_sidebar: CommandsModeratorSidebarResponse
  commands_modification_history: CommandsModificationHistoryResponse
  commands_sidebar: CommandsSidebarResponse
  commands_stock: CommandsStockResponse
  complaints: ComplaintsResponse
  dokploy_config: DokployConfigResponse
  envoi_sidebar: EnvoiSidebarResponse
  factures: FacturesResponse
  factures_details: FacturesDetailsResponse
  factures_moderator_sidebar: FacturesModeratorSidebarResponse
  factures_sidebar: FacturesSidebarResponse
  fees: FeesResponse
  global_settings: GlobalSettingsResponse
  history_log: HistoryLogResponse
  import_history: ImportHistoryResponse
  livreurs_statuses_count: LivreursStatusesCountResponse
  mobile_app: MobileAppResponse
  packaging: PackagingResponse
  statuses_count: StatusesCountResponse
  stock_records: StockRecordsResponse
  stocks: StocksResponse
  top_cities: TopCitiesResponse
  top_clients: TopClientsResponse
  top_dlms: TopDlmsResponse
  tracking_states: TrackingStatesResponse
  users: UsersResponse
  whatsapp_message_events: WhatsappMessageEventsResponse
  whatsapp_messages: WhatsappMessagesResponse
}

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = PocketBase & {
  collection(idOrName: '_authOrigins'): RecordService<AuthoriginsResponse>
  collection(idOrName: '_externalAuths'): RecordService<ExternalauthsResponse>
  collection(idOrName: '_mfas'): RecordService<MfasResponse>
  collection(idOrName: '_otps'): RecordService<OtpsResponse>
  collection(idOrName: '_superusers'): RecordService<SuperusersResponse>
  collection(idOrName: 'announces'): RecordService<AnnouncesResponse>
  collection(
    idOrName: 'api_token_history'
  ): RecordService<ApiTokenHistoryResponse>
  collection(idOrName: 'api_tokens'): RecordService<ApiTokensResponse>
  collection(idOrName: 'bons'): RecordService<BonsResponse>
  collection(idOrName: 'cities'): RecordService<CitiesResponse>
  collection(idOrName: 'commands'): RecordService<CommandsResponse>
  collection(
    idOrName: 'commands_attachements'
  ): RecordService<CommandsAttachementsResponse>
  collection(
    idOrName: 'commands_history'
  ): RecordService<CommandsHistoryResponse>
  collection(
    idOrName: 'commands_moderator_sidebar'
  ): RecordService<CommandsModeratorSidebarResponse>
  collection(
    idOrName: 'commands_modification_history'
  ): RecordService<CommandsModificationHistoryResponse>
  collection(
    idOrName: 'commands_sidebar'
  ): RecordService<CommandsSidebarResponse>
  collection(idOrName: 'commands_stock'): RecordService<CommandsStockResponse>
  collection(idOrName: 'complaints'): RecordService<ComplaintsResponse>
  collection(idOrName: 'dokploy_config'): RecordService<DokployConfigResponse>
  collection(idOrName: 'envoi_sidebar'): RecordService<EnvoiSidebarResponse>
  collection(idOrName: 'factures'): RecordService<FacturesResponse>
  collection(
    idOrName: 'factures_details'
  ): RecordService<FacturesDetailsResponse>
  collection(
    idOrName: 'factures_moderator_sidebar'
  ): RecordService<FacturesModeratorSidebarResponse>
  collection(
    idOrName: 'factures_sidebar'
  ): RecordService<FacturesSidebarResponse>
  collection(idOrName: 'fees'): RecordService<FeesResponse>
  collection(idOrName: 'global_settings'): RecordService<GlobalSettingsResponse>
  collection(idOrName: 'history_log'): RecordService<HistoryLogResponse>
  collection(idOrName: 'import_history'): RecordService<ImportHistoryResponse>
  collection(
    idOrName: 'livreurs_statuses_count'
  ): RecordService<LivreursStatusesCountResponse>
  collection(idOrName: 'mobile_app'): RecordService<MobileAppResponse>
  collection(idOrName: 'packaging'): RecordService<PackagingResponse>
  collection(idOrName: 'statuses_count'): RecordService<StatusesCountResponse>
  collection(idOrName: 'stock_records'): RecordService<StockRecordsResponse>
  collection(idOrName: 'stocks'): RecordService<StocksResponse>
  collection(idOrName: 'top_cities'): RecordService<TopCitiesResponse>
  collection(idOrName: 'top_clients'): RecordService<TopClientsResponse>
  collection(idOrName: 'top_dlms'): RecordService<TopDlmsResponse>
  collection(idOrName: 'tracking_states'): RecordService<TrackingStatesResponse>
  collection(idOrName: 'users'): RecordService<UsersResponse>
  collection(
    idOrName: 'whatsapp_message_events'
  ): RecordService<WhatsappMessageEventsResponse>
  collection(
    idOrName: 'whatsapp_messages'
  ): RecordService<WhatsappMessagesResponse>
}
